export default __webpack_public_path__ + "static/polygon-07667c90c4608998e91d8e7c917f6167.png";